export default {"src":"/planos/_next/static/media/equifax-phone-ring.64be7c82.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};